export default "__VITE_ASSET__DtoaNkZZ__"